// extracted by mini-css-extract-plugin
module.exports = {"home_box":"home_box-3qj6mYVy"};